<template>
  <div class="sticky top-[130px] sm:z-2 bg-white h-[245px] w-[327px] border-[3px] border-black/[.08] rounded-xl py-4">
    <div class="flex flex-col px-6 py-2 justify-between">
      <p class="text-black text-[19px] font-semibold leading-28 mb-4">{{ current }} Hakkında Bilgiler</p>
      <p class="text-[#6D707D] text-lg font-normal leading-24 mb-4">
        {{ current }} Kelime Oyunu'nu oynamanın ve ekstra puan kazanmanın inceliklerini buradan öğren! Heyecan dolu bilgiler seni bekliyor.
      </p>
      <OButton pure @click="showHelpModal(currentTab)">
        <p class="u-center text-base leading-22 font-semibold text-[#414141]">Oyun Klavuzuna Git ></p>
      </OButton>
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { useModal } from '~/composables/useModal';
import { OButton } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OButton },
  setup(props) {
    const { openModal } = useModal();

    const current = props.currentTab?.charAt(0).toUpperCase() + props.currentTab.slice(1).toLowerCase();
    const showHelpModal = (game) => {
      if (game === 'emojile') {
        openModal(import('~/modules/emojile/components/ModalEmojileHelp' /* webpackChunkName: "ModalEmojileHelp" */));
      } else openModal(import('~/modules/bilpop/components/ModalBilpopHelp' /* webpackChunkName: "ModalBilpopHelp" */));
      // setTimeout(() => {
      //   const elem = document.getElementById('modal');
      //   if (elem) {
      //     elem.style.transform = 'translateY(0)';
      //   }
      // }, 100);
    };
    return { current, showHelpModal };
  },
  props: {
    currentTab: {
      required: true,
      type: String,
    },
  },
});
</script>
<style scoped lang="scss"></style>
